import './lib/smooth-scroll.js'
import './lib/copyright.js'
import './lib/newsletter.js'

const target = document.querySelector('#section-roadmap > .content'),
      url = 'https://cdn.author.io/roadmap',
      runtime = await (await fetch(`${url}/runtime_roadmap.json?bust=${new Date().getTime()}`)).json()

const template = document.createElement('template')

template.innerHTML = `
  <section class="runtime">
    <header>
      <h3>Runtime Beta</h3>
    </header>

    <ol class="items">
      ${getListItems(runtime.milestone['Beta'])}
    </ol>
  </section>
`

target.append(template.content)

function getListItems ({ items }) {
  return items.reduce((html, {
    complete,
    description,
    public: isPublic,
    status,
    title
  }) => isPublic ? html + `
    <li${complete ? ' class="complete"' : ''}>
      ${complete ? `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="check-circle icon">
          <path d="M21.801 10A10 10 0 1 1 17 3.335"/>
          <path d="m9 11 3 3L22 4"/>
        </svg>
      ` : `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="circle icon">
          <circle cx="12" cy="12" r="10"/>
        </svg>
      `}

      <div class="title">
        ${title}
      </div>
      
      <div class="tags">
        <span class="status tag">${status}</span>
      </div>

      <p class="description">${description}</p>
    </li>
  ` : html, '')
}